import {
  UserLayout,
  BasicLayout,
  RouteView,
  BlankLayout,
  PageView
} from '@/layouts'
import {
  bxAnaalyse,
  setting_fill
} from '@/core/icons'

//路由/菜单及Icon图标说明https://github.com/sendya/ant-design-pro-vue/blob/master/src/router/README.md
//Icon图标下载https://www.iconfont.cn/collections/detail?spm=a313x.7781069.1998910419.de12df413&cid=9402
export const asyncRouterMap = [{
    path: '/',
    name: 'index',
    redirect: '/Seller/dashboard/Main',
    component: BasicLayout,
    meta: {
      title: '首页'
    },
    children: [
      // 控制台
      {
        path: '/Seller',
        redirect: '/Seller/dashboard/Main',
        name: 'dashboard',
        component: PageView,
        meta: {
          title: '仪表盘',
          icon: bxAnaalyse,
          permission: ['dashboard']
        },
        children: [{
          path: '/Seller/dashboard/Main',
          name: 'Main',
          component: () => import('@/views/dashboard/Main'),
          meta: {
            title: '首页',
            permission: ['dashboard']
          }
        }, {
          path: '/Seller/dashboard/WebSocket',
          name: 'WebSocket',
          component: () => import('@/views/dashboard/WebSocket'),
          meta: {
            title: 'WebSocket',
            permission: ['dashboard']
          },
          hidden: true
        }],
      },
      {
        path: '/Seller/base',
        name: 'base',
        component: PageView,
        meta: {
          title: '基础功能',
          icon: 'setting',
          permission: ['dashboard']
        },
        children: [{
          path: '/Seller/base/ChangePasswd',
          name: 'ChangePasswd',
          component: () => import('@/views/base/ChangePasswd'),
          meta: {
            title: '修改密码',
            permission: ['dashboard']
          }
        }, {
          path: '/Seller/SellerCoupons/SellerRechargeList',
          name: 'SellerRechargeList',
          component: () => import('@/views/SellerCoupons/SellerRechargeList'),
          meta: {
            title: '充值明细',
            permission: ['dashboard']
          }
        }, {
          path: '/Seller/SellerCoupons/SellerRecharge',
          name: 'SellerRecharge',
          component: () => import('@/views/SellerCoupons/SellerRecharge'),
          meta: {
            title: '在线充值',
            permission: ['dashboard']
          },
          hidden: true
        }]
      },
      {
        path: '/Seller/SellerCoupons',
        name: 'SellerCoupons',
        component: PageView,
        meta: {
          title: '优惠券管理',
          icon: 'credit-card',
          permission: ['dashboard']
        },
        children: [{
          path: '/Seller/SellerCoupons/AllMoneyCoupons',
          name: 'AllMoneyCoupons',
          component: () => import('@/views/SellerCoupons/AllMoneyCoupons'),
          meta: {
            title: '全免优惠券',
            permission: ['dashboard']
          }
        }, {
          path: '/Seller/SellerCoupons/MultipleTimeCoupons',
          name: 'MultipleTimeCoupons',
          component: () => import('@/views/SellerCoupons/MultipleTimeCoupons'),
          meta: {
            title: '多次全免优惠券',
            permission: ['dashboard']
          }
        }, {
          path: '/Seller/SellerCoupons/MoneyCoupon',
          name: 'MoneyCoupon',
          component: () => import('@/views/SellerCoupons/MoneyCoupon'),
          meta: {
            title: '免金额优惠券',
            permission: ['dashboard']
          }
        }, {
          path: '/Seller/SellerCoupons/RechargeCoupon',
          name: 'RechargeCoupon',
          component: () => import('@/views/SellerCoupons/RechargeCoupon'),
          meta: {
            title: '充值优惠券',
            permission: ['dashboard']
          }
        }, {
          path: '/Seller/SellerCoupons/NumberCoupon',
          name: 'NumberCoupon',
          component: () => import('@/views/SellerCoupons/NumberCoupon'),
          meta: {
            title: '次卡优惠券',
            permission: ['dashboard']
          }
        }, {
          path: '/Seller/SellerCoupons/TimeLimitedCoupons',
          name: 'TimeLimitedCoupons',
          component: () => import('@/views/SellerCoupons/TimeLimitedCoupons'),
          meta: {
            title: '免时优惠券',
            permission: ['dashboard']
          }
        }, {
          path: '/Seller/SellerCoupons/UpperLimitCoupon',
          name: 'UpperLimitCoupon',
          component: () => import('@/views/SellerCoupons/UpperLimitCoupon'),
          meta: {
            title: '24H上限优惠券',
            permission: ['dashboard']
          }
        }]
      }
    ]
  }, {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [{
      path: '/user/login',
      name: 'login',
      component: () => import('@/views/user/Login')
    }]
  },
  // {
  //   path: '*',
  //   redirect: '/404',
  //   hidden: true
  // }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [{
  path: '/user',
  component: UserLayout,
  redirect: '/user/login',
  hidden: true,
  children: [{
    path: '/user/login',
    name: 'login',
    component: () => import('@/views/user/Login')
  }]
}]